import { render, staticRenderFns } from "./Safe.vue?vue&type=template&id=a013ae14&scoped=true&"
import script from "./Safe.vue?vue&type=script&lang=js&"
export * from "./Safe.vue?vue&type=script&lang=js&"
import style0 from "./Safe.vue?vue&type=style&index=0&id=a013ae14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a013ae14",
  null
  
)

export default component.exports